(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-menu-ajax"] && !Shopify.designMode) return;
  try {
    

(function () {
  function initializeAccessories() {
    var $ = window.jQuery;
    if (!$) return;

    var $container = $('.collectionMenu-container');
    var $collections = $container.children('.product-collection');
    var $desktopItems = $('.page-width.custom-collection .collection-menu .menu-item');
    var $mobileItems = $collections.children('.menu-item');

    if (!$collections.length) return;

    var initialHandle = $collections.first().attr('id');
    var activeHandle = initialHandle;

    function showCollection(handle) {
      activeHandle = handle;

      var isMobile = window.innerWidth <= 767;

      $collections.each(function () {
        var $collection = $(this);
        var isSelected = this.id === handle;

        if (isMobile) {
          // Keep all category tabs visible
          $collection.css('display', 'flex');

          // Expand selected category only
          $collection.children('.product-details')
            .css('display', isSelected ? 'block' : 'none');
        } else {
          // Desktop: show selected collection only
          $collection.css('display', isSelected ? 'flex' : 'none');

          $collection.children('.product-details')
            .css('display', '');
        }
      });

      $desktopItems.removeClass('active');
      $desktopItems.filter(function () {
        return $(this).children('a').attr('id') === handle;
      }).addClass('active');

      $mobileItems.removeClass('active');
      $mobileItems.filter(function () {
        return $(this).parent().attr('id') === handle;
      }).addClass('active');
    }

    showCollection(initialHandle);

    // Desktop navigation
    $desktopItems.off('click.accessories')
      .on('click.accessories', function (e) {
        e.preventDefault();
        showCollection($(this).children('a').attr('id'));
      });

    // Mobile accordion navigation
    $mobileItems.off('click.accessories')
      .on('click.accessories', function (e) {
        e.preventDefault();

        if (window.innerWidth > 767) return;

        var handle = $(this).parent().attr('id');

        if (handle === activeHandle) {
          // Collapse the currently open category
          activeHandle = null;

          $collections.children('.product-details').hide();
          $mobileItems.removeClass('active');
        } else {
          showCollection(handle);
        }
      });

    // Adjust when screen size changes
    $(window).off('resize.accessories')
      .on('resize.accessories', function () {
        showCollection(activeHandle || initialHandle);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAccessories);
  } else {
    initializeAccessories();
  }
})();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__accordionJump) return;
  window.__accordionJump = true;

  // The section we jump TO: Assembly Guides ("Accordion with 8 Content Items").
  var TARGET_SECTION = '.shopify-section[id*="__new_accordion"]';
  // The clickable bar inside it, and the class it carries while open.
  var BAR = '.accordion';
  var OPEN_CLASS = 'active';
  // Link names that should open a bar with a different title.
  // Bars already answer to their own title: #garage-cabinets, #shelving-racks, #accessories.
  var ALIASES = {
    'gear-lockers': 'garage-cabinets',
    'gear-locker': 'garage-cabinets'
  };
  // Link name that scrolls to the top of the whole section without opening anything.
  var SECTION_NAME = 'assemblyguides';
  // Breathing room under the pinned announcement bar, in px.
  var GAP = 12;

  var timer;

  // "Shelving & Racks" -> "shelving-racks", "#Gear-Lockers" -> "gear-lockers"
  function slugify(text) {
    return String(text || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // What a hash points at: an accordion bar, the section itself, or nothing.
  function findTarget(hash) {
    var slug;
    try { slug = slugify(decodeURIComponent(hash || '')); } catch (e) { return null; }
    if (!slug) return null;
    var section = document.querySelector(TARGET_SECTION);
    if (!section) return null;
    if (slug === SECTION_NAME) return { el: section.querySelector('h2') || section, open: false };
    slug = ALIASES[slug] || slug;
    var bars = section.querySelectorAll(BAR);
    for (var i = 0; i < bars.length; i++) {
      if (slugify(bars[i].id) === slug || slugify(bars[i].textContent) === slug) return { el: bars[i], open: true };
    }
    return null;
  }

  // Height of whatever is pinned to the top of the screen right now (the announcement bar,
  // a sticky header). Measured live, so it is right at every screen size.
  function pinnedHeight() {
    var y = 0;
    for (var i = 0; i < 4; i++) {
      var el = document.elementFromPoint(window.innerWidth / 2, y + 1);
      var bottom = y;
      for (; el && el !== document.documentElement; el = el.parentElement) {
        var pos = getComputedStyle(el).position;
        if (pos !== 'fixed' && pos !== 'sticky') continue;
        var rect = el.getBoundingClientRect();
        if (rect.height <= window.innerHeight * 0.4 && rect.bottom > bottom) bottom = rect.bottom;
      }
      if (bottom <= y) break;
      y = bottom;
    }
    return y;
  }

  function jumpTo(target) {
    var el = target.el;
    clearInterval(timer);
    if (target.open && !el.classList.contains(OPEN_CLASS)) el.click();

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = reduceMotion ? 'auto' : 'smooth';
    var offBy = function () {
      return el.getBoundingClientRect().top - pinnedHeight() - GAP;
    };

    window.scrollBy({ top: offBy(), behavior: behavior });

    // The panel animates open and images may still be loading, which moves the page under us.
    // Wait until the target stops moving, then correct whatever distance is left.
    var last = null, still = 0, ticks = 0;
    timer = setInterval(function () {
      var top = el.getBoundingClientRect().top;
      still = last !== null && Math.abs(top - last) < 1 ? still + 1 : 0;
      last = top;
      if (still >= 2 || ++ticks > 30) {
        clearInterval(timer);
        if (Math.abs(offBy()) > 2) window.scrollBy({ top: offBy(), behavior: behavior });
      }
    }, 120);
  }

  // Never fight the visitor if they start scrolling themselves.
  ['wheel', 'touchmove', 'keydown'].forEach(function (name) {
    window.addEventListener(name, function () { clearInterval(timer); }, { passive: true });
  });

  function samePage(link) {
    var clean = function (path) { return path.replace(/\/+$/, ''); };
    return link.host === location.host && clean(link.pathname) === clean(location.pathname);
  }

  // Any link on this page that points at one of the names above, e.g. #gear-lockers
  document.addEventListener('click', function (e) {
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!link || !samePage(link)) return;
    var target = findTarget(link.hash);
    if (!target) return;
    e.preventDefault();
    history.replaceState(null, '', link.hash);
    jumpTo(target);
  });

  // Arriving from another page (/pages/resources#gear-lockers), or using back/forward.
  function fromHash() {
    var target = findTarget(location.hash);
    if (target) jumpTo(target);
  }
  if (document.readyState === 'complete') setTimeout(fromHash, 0);
  else window.addEventListener('load', fromHash);
  window.addEventListener('hashchange', fromHash);
})();

  } catch(e) { console.error(e); }
})();
})();
